import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import useTranslate from "../../../../core/languages/hooks/useTranslate";
import HotelRoom from "../../../../hotels/types/HotelRoom";
import Loader from "../../../../ui/shared/Loader/Loader";
import HotelPackageRoomCard from "../../cards/HotelPackageRoomCard";
import Prebooking from "../../../../booking/types/Prebooking";
import useGetBasketItems from "../../../../booking/hooks/useGetBasketItems";
import useHotelGetRoomsInfo from "../../../../hotels/hooks/useHotelGetRoomsInfo";
import {SalesChannelEnum} from "../../../../common/enums/SalesChannelEnum";
import EventCity from "../../../../eventCities/types/EventCity";
import {WizardSaveInput} from "../../../types/WizardSaveInput";
import {extractIdFromPath} from "../../../../transfers/utils/extractIdFromPath";

interface StepSelectPackageRoomProps {
  preBooking: Prebooking;
  accommodationDates?: {
    startDate: string,
    endDate: string
  };
  eventCity: EventCity;
}

const StepSelectPackageRoom: React.FC<StepSelectPackageRoomProps> = ({preBooking, accommodationDates, eventCity}) => {
  const t = useTranslate();
  const {control ,formState: {errors}} = useFormContext<WizardSaveInput>();

  const eventHotelId = extractIdFromPath(preBooking.prebookingHotel?.hotelEvent);

  const preBookingHotelRoomsQuery = useGetBasketItems(preBooking.internalId, { execute: !!preBooking.internalId  });
  const {data: preBookingHotelRooms} = preBookingHotelRoomsQuery;
  const hotelRoomsQuery = useHotelGetRoomsInfo(eventHotelId, accommodationDates?.startDate, accommodationDates?.endDate, { salesChannel: SalesChannelEnum.PACKAGE, execute: !!eventHotelId && !!preBooking });
  const {data: hotelRooms} = hotelRoomsQuery;

  if (!preBookingHotelRooms || !hotelRooms) {
    return <Loader centerHorizontally />;
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-neutral-900 dark:text-white">
          {t("packages.fields.selectRoom")}
        </h2>
        <p className="text-neutral-600 dark:text-neutral-400 mt-2">
          {t("packages.validation.selectRoomDescription")}
        </p>
      </div>

      <Controller name="selectedRoomId" control={control} rules={{required: t("packages.validation.roomRequired")}}
        render={({ field: _field }) => (
          <div className={`p-4 rounded-lg transition ${
            errors.selectedRoomId ? 
              "border-2 border-red-500 bg-red-50 dark:bg-red-950" 
              : "border border-transparent"
          }`}>
            <div className="flex-grow mt-4 lg:mt-4">
              <div className="sticky top-28 grid grid-cols-1 lg:grid-cols-2 gap-2">
                {hotelRooms ? hotelRooms.map((room: HotelRoom) => (
                    <HotelPackageRoomCard
                      key={room.id}
                      preBooking={preBooking}
                      accommodationDates={accommodationDates}
                      hotelRoom={room}
                      preBookingHotelRooms={preBookingHotelRooms}
                      eventCity={eventCity}
                    />
                  ))
                  :
                    <Loader centerHorizontally/>
                }
              </div>
            </div>
          </div>
        )}
      />

      {errors.selectedRoomId && (
        <div className="bg-red-50 dark:bg-red-950 border-2 border-red-500 rounded-lg p-4">
          <p className="text-red-700 dark:text-red-300 font-medium flex items-center">
            <i className="las la-exclamation-circle mr-2"></i>
            {errors.selectedRoomId.message}
          </p>
        </div>
      )}
    </div>
  );
};

export default StepSelectPackageRoom;



